// src/components/ErrorBoundary.jsx
//
// Простой error boundary. Ловит ошибки рендера и показывает их на экране
// вместо белого экрана. Используется в App.jsx чтобы обернуть Routes.

import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    console.error('ErrorBoundary caught:', error, info);
  }

  reset = () => {
    this.setState({ error: null, info: null });
  };

  render() {
    if (!this.state.error) return this.props.children;

    const errorText = this.state.error?.toString() || 'Unknown error';
    const stackText = this.state.info?.componentStack || this.state.error?.stack || '';

    return (
      <div style={{
        padding: 20,
        minHeight: '100vh',
        background: '#fff',
        color: '#000',
        fontFamily: 'monospace',
        fontSize: 12,
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch',
      }}>
        <h2 style={{ color: '#dc2626', fontSize: 18, marginBottom: 12, fontFamily: 'sans-serif' }}>
          Что-то сломалось
        </h2>

        <div style={{
          background: '#fee2e2', padding: 12, borderRadius: 6,
          marginBottom: 12, wordBreak: 'break-word',
        }}>
          <strong>Ошибка:</strong><br />
          {errorText}
        </div>

        {stackText && (
          <details style={{ marginBottom: 12 }}>
            <summary style={{ cursor: 'pointer', fontFamily: 'sans-serif', fontSize: 13 }}>
              Где упало (стек)
            </summary>
            <pre style={{
              background: '#f3f4f6', padding: 12, borderRadius: 6,
              fontSize: 10, whiteSpace: 'pre-wrap', wordBreak: 'break-word',
              marginTop: 8,
            }}>
              {stackText}
            </pre>
          </details>
        )}

        <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
          <button
            onClick={this.reset}
            style={{
              flex: 1, padding: '12px 16px', borderRadius: 6,
              background: '#6366F1', color: '#fff', border: 'none',
              fontWeight: 700, fontSize: 14, cursor: 'pointer', fontFamily: 'sans-serif',
            }}
          >
            Попробовать ещё раз
          </button>
          <button
            onClick={() => { window.location.hash = '#/'; this.reset(); }}
            style={{
              flex: 1, padding: '12px 16px', borderRadius: 6,
              background: '#e5e7eb', color: '#111', border: 'none',
              fontWeight: 700, fontSize: 14, cursor: 'pointer', fontFamily: 'sans-serif',
            }}
          >
            На главную
          </button>
        </div>

        <p style={{ marginTop: 16, fontSize: 11, color: '#6b7280', fontFamily: 'sans-serif' }}>
          Сделай скриншот этого экрана и пришли разработчику
        </p>
      </div>
    );
  }
}
